import { CareMapState } from '../caremap/CareMapState';
import { INewCareMap } from '../caremap/ICareMap';

export class CareTabsProvider {

    static inject = () => [CareMapState];
    constructor(private careMapState: CareMapState) {}

    // Status is for care recipients an organization looks after, and the api decides which those are.
    offersStatus = (careMap: INewCareMap): boolean => {
        return Boolean(careMap.links?.careStatus);
    };

    getTabs = () => {
        const careMap = this.careMapState.getActiveCaremap();
        if (!careMap) {
            throw new Error('No active care map!');
        }

        const incompleteRedirect = this.careMapState.isIncomplete(careMap) ? '/q/new-care-recipient' : undefined;

        // Left of Profile because it answers the first question anybody has when they open this
        // section, which is how the person is rather than what is on file about them. Dropped while
        // the care map is incomplete: there is nothing recorded to draw yet, and every tab shares the
        // onboarding url in that state, so the tab bar would underline Status and then remember it as
        // the last place the user was.
        const statusTab = incompleteRedirect || !this.offersStatus(careMap)
            ? []
            : [{ label: 'Status', url: `/status/${careMap.careMapId}`, dataId: 'status-tab' }];

        // The profile and the care map are care details; a reader the api withholds them from has
        // only the notes here.
        const detailTabs = this.careMapState.hasPermissionTo('get-care-details')
            ? [
                { label: 'Profile', url: incompleteRedirect || `/care/${careMap.careMapId}`, dataId: 'profile-tab' },
                { label: 'Care Map', url: incompleteRedirect || `/caremaps/${careMap.careMapId}`, dataId: 'caremap-tab' }
            ]
            : [];

        return {
            tabGroupId: 'care-tabs',
            tabs: [
                ...statusTab,
                ...detailTabs,
                { label: 'Notes', url: `/notes/${careMap.careMapId}`, dataId: 'notes-tab' }
            ]
        };
    };
}
